export default __webpack_public_path__ + "static/media/privilege-3.134aa636.svg";